import { Outlet, RouteObject } from 'react-router-dom';
import routeConfig from 'app/config/routes';
import PdfPageStyle from 'app/modules/public/components/PdfPageStyle';
import AnalyticsReportPdfStyles from './AnalyticsReportPdfStyles';
import AnalyticsReportPublicRoute from './AnalyticsReportPublicRoute';

export const publicAnalyticsReportsRouter: RouteObject = {
  path: routeConfig.public.routes.analyticsReports.path,
  element: (
    <PdfPageStyle>
      <AnalyticsReportPdfStyles />
      <Outlet />
    </PdfPageStyle>
  ),
  children: [
    {
      path: routeConfig.public.routes.analyticsReports.routes.view.path,
      element: <AnalyticsReportPublicRoute />,
    },
  ],
};
